import store from '../../store'
import { login, getInfo, getService, joinService } from '@/api/login'
import { getBranchById } from '@/api/branch'
import { signup } from '@/api/signup'
import { getCompanies } from '@/api/company'
import { getRelations } from '@/api/relation'
import { getUnreadNotifications } from '@/api/serviceNotifications'

// import { getToken, setToken, removeToken } from '@/utils/auth'

const defaultFeatures = {
  // accounting: false
}
const listOfFeatures = [
  // {
  //   key: "accounting"
  // }
]

const user = {
  state: {
    id: '',
    token: '',
    username: '',
    name: '',
    email: '',
    description: {},
    avatar: '',
    confirmed: false,
    role: '',
    awakRole: '',
    userData: {},
    branchData: {},
    branchLogo: null,
    features: {
      // accounting: false
    },
    unreadNotifications: 0,
    companies: []
  },
  getters: {
    id: state => state.id,
    token: state => state.token,
    avatar: state => state.avatar,
    username: state => state.username,
    name: state => state.name,
    email: state => state.email,
    description: state => state.description,
    confirmed: state => state.confirmed,
    role: state => state.role,
    awakRole: state => state.awakRole,
    userData: state => state.userData,
    profilePicture: state => state.profilePicture,
    branchData: state => state.branchData,
    branchLogo: state => state.branchLogo,
    features: state => state.features,
    unreadNotifications: state => state.unreadNotifications,
    companies: state => state.companies
  },
  mutations: {
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_DESCRIPTION: (state, description) => {
      state.description = description
    },
    SET_CONFIRMED: (state, confirmed) => {
      state.confirmed = confirmed
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_AWAK_ROLE: (state, awakRole) => {
      state.awakRole = awakRole
    },
    SET_USER_DATA: (state, userData) => {
      state.userData = userData
    },
    SET_PROFILE_PICTURE: (state, profilePicture) => {
      state.profilePicture = profilePicture
    },
    SET_BRANCH_DATA: (state, branchData) => {
      state.branchData = branchData
    },
    SET_BRANCH_LOGO: (state, branchLogo) => {
      state.branchLogo = branchLogo
    },
    SET_FEATURES: (state, features) => {
      state.features = features
    },
    SET_UNREAD_NOTIFICATIONS: (state, unreadNotifications) => {
      state.unreadNotifications = unreadNotifications
    },
    SET_COMPANIES: (state, companies) => {
      state.companies = companies
    }
  },

  actions: {
    Login({ dispatch, commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response
          // console.log('data: ' + JSON.stringify(data))
          // setToken(data.jwt)
          commit('SET_TOKEN', data.jwt)
          // commit('SET_NAME', data.user.name)
          commit('SET_USERNAME', data.user.username)
          commit('SET_EMAIL', data.user.email)
          commit('SET_CONFIRMED', data.user.confirmed)
          getService().then(response2 => {
            const data2 = response2
            if (data2.package === undefined) {
              data2.package = 'none'
            }
            commit('SET_AWAK_ROLE', data2.package)
            commit('SET_USER_DATA', data2.userData)
            commit('SET_PROFILE_PICTURE', data2.userData && data2.userData.pfp ? data2.userData.pfp.path : null)
            getRelations().then(async response3 => {
              const data3 = response3.data
              let branchId = null
              let features = defaultFeatures
              commit('SET_COMPANIES', data3)
              resolve({ companies: data3, awakRole: data2.package, userData: data2.userData, features: features, ...data })
            })
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    SignInPlatform({ dispatch, commit }, data) {
      return new Promise((resolve, reject) => {
        // console.log('data: ' + JSON.stringify(data))
        // setToken(data.jwt)
        commit('SET_TOKEN', data.jwt)
        // commit('SET_NAME', data.user.name)
        commit('SET_USERNAME', data.user.username)
        commit('SET_EMAIL', data.user.email)
        commit('SET_CONFIRMED', data.user.confirmed)
        getService().then(response2 => {
          const data2 = response2
          if (data2.package === undefined) {
            data2.package = 'none'
          }
          commit('SET_AWAK_ROLE', data2.package)
          commit('SET_USER_DATA', data2.userData)
          commit('SET_PROFILE_PICTURE', data2.userData && data2.userData.pfp ? data2.userData.pfp.path : null)
          resolve({ awakRole: data2.package, userData: data2.userData, ...data })
        })
      })
    },
    Signup({ dispatch, commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        signup(username, userInfo.email, userInfo.password).then(response => {
          const data = response
          commit('SET_TOKEN', data.jwt)
          commit('SET_USERNAME', data.user.username)
          commit('SET_EMAIL', data.user.email)
          commit('SET_CONFIRMED', data.user.confirmed)

          joinService(userInfo).then((response) => {
            getService().then(response2 => {
              const data2 = response2
              if (data2.package === undefined) {
                data2.package = 'none'
              }
              commit('SET_AWAK_ROLE', data2.package)
              commit('SET_USER_DATA', data2.userData)
              commit('SET_PROFILE_PICTURE', data2.userData && data2.userData.pfp ? data2.userData.pfp.path : null)
              resolve({ awakRole: data2.package, userData: data2.userData, ...data })
            })
          })
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetInfo({ commit, state }, path) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response
          if (data.role && data.role.type) {
            commit('SET_ROLE', data.role.type)
          } else {
            reject('getInfo: role not found !')
          }
          // commit('SET_NAME', data.user.name)
          commit('SET_ID', data._id)
          commit('SET_USERNAME', data.username)
          commit('SET_EMAIL', data.email)
          commit('SET_DESCRIPTION', data.description)
          commit('SET_CONFIRMED', data.confirmed)
          commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.username}`)
          commit('SET_BRANCH_SELECTED', null)
          commit('SET_BRANCH_DATA', {})
          commit('SET_BRANCH_LOGO', null)

          let relationRole = null

          let routeBranchId = null
          if (path.split('/').length > 2 && path.split('/')[1] === 'z') {
            const branchId = path.split('/')[2]
            routeBranchId = branchId
          }

          getService().then(async response2 => {
            const data2 = response2
            if (data2.package === undefined) {
              data2.package = 'none'
            }
            commit('SET_AWAK_ROLE', data2.package)
            commit('SET_USER_DATA', data2.userData)
            commit('SET_PROFILE_PICTURE', data2.userData && data2.userData.pfp ? data2.userData.pfp.path : null)
            getRelations().then(async response3 => {
              const data3 = response3.data
              let branchId = null
              let features = defaultFeatures
              commit('SET_COMPANIES', data3)
              if (routeBranchId) {
                try {
                  const resp = await getBranchById(routeBranchId)
                  branchId = routeBranchId
                  commit('SET_BRANCH_SELECTED', routeBranchId)
                  commit('SET_BRANCH_DATA', resp)
                  // console.log('SET_BRANCH_DATA', resp)
                  commit('SET_BRANCH_LOGO', resp.logo ? resp.logo.path : false)
                  relationRole = resp.relation.role
                  if (resp.features.length > 0) {
                    const featureList = resp.features
                    for (var i in listOfFeatures) {
                      const feature = featureList.find((v) => v.featureFlag === listOfFeatures[i].key)
                      if (feature) {
                        features[listOfFeatures[i].key] = feature.activated
                        switch (listOfFeatures[i].key) {
                          case 'mindblogging': {
                            store.dispatch('SetUserHandle', feature.settings ? feature.settings.userHandle : '');
                            break
                          }
                        }
                      }
                    }
                  } else if (resp.regionId) {
                    if (resp.regionId.features.length > 0) {
                      const featureList = resp.regionId.features
                      for (var i in listOfFeatures) {
                        const feature = featureList.find((v) => v.featureFlag === listOfFeatures[i].key)
                        if (feature) {
                          features[listOfFeatures[i].key] = feature.activated
                          switch (listOfFeatures[i].key) {
                            case 'mindblogging': {
                              store.dispatch('SetUserHandle', feature.settings ? feature.settings.userHandle : '');
                              break
                            }
                          }
                        }
                      }
                    } else if (resp.regionId.companyId && resp.regionId.companyId.features.length > 0) {
                      const featureList = resp.regionId.companyId.features
                      for (var i in listOfFeatures) {
                        const feature = featureList.find((v) => v.featureFlag === listOfFeatures[i].key)
                        if (feature) {
                          features[listOfFeatures[i].key] = feature.activated
                          switch (listOfFeatures[i].key) {
                            case 'mindblogging': {
                              store.dispatch('SetUserHandle', feature.settings ? feature.settings.userHandle : '');
                              break
                            }
                          }
                        }
                      }
                    }
                  }
                } catch (err) {
                  commit('SET_BRANCH_SELECTED', null)
                  commit('SET_BRANCH_DATA', {})
                  commit('SET_BRANCH_LOGO', null)
                }
              }
              commit('SET_FEATURES', features)
              if (branchId) {
                try {
                  const unread = await getUnreadNotifications(branchId)
                  commit('SET_UNREAD_NOTIFICATIONS', unread.count)
                } catch (err) {
                  console.log(err)
                }
              }
              resolve({ companies: data3, awakRole: data2.package, userData: data2.userData, features: features, relationRole: relationRole, ...data })
            })
          })
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetUnreadMessages({ commit, state }, branchId) {
      return new Promise(async(resolve, reject) => {
        if (branchId) {
          try {
            const unread = await getUnreadNotifications(branchId)
            commit('SET_UNREAD_NOTIFICATIONS', unread.count)
          } catch (err) {
            console.log(err)
          }
        }
        resolve()
      })
    },

    GetBranch({ commit, state }, branchId) {
      return new Promise(async(resolve, reject) => {
        try {
          const resp = await getBranchById(branchId)
          commit('SET_BRANCH_SELECTED', branchId)
          commit('SET_BRANCH_DATA', resp)
          commit('SET_BRANCH_LOGO', resp.logo ? resp.logo.path : false)
          let features = defaultFeatures
          if (resp.features.length > 0) {
            const featureList = resp.features
            for (var i in listOfFeatures) {
              features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
            }
          } else if (resp.regionId) {
            if (resp.regionId.features.length > 0) {
              const featureList = resp.regionId.features
              for (var i in listOfFeatures) {
                features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              }
            } else if (resp.regionId.companyId && resp.regionId.companyId.features.length > 0) {
              const featureList = resp.regionId.companyId.features
              for (var i in listOfFeatures) {
                features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              }
            }
          }
          commit('SET_FEATURES', features)
          if (branchId) {
            try {
              const unread = await getUnreadNotifications(branchId)
              commit('SET_UNREAD_NOTIFICATIONS', unread.count)
            } catch (err) {
              console.log(err)
            }
          }
          resolve({ ...resp })
        } catch (err) {
          reject(err)
        }
      })
    },
    // 登出
    LogOut({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLE', '')
        commit('SET_NAME', '')
        commit('SET_USERNAME', '')
        commit('SET_EMAIL', '')
        commit('SET_AVATAR', '')
        commit('SET_DESCRIPTION', '')
        commit('SET_CONFIRMED', '')
        commit('SET_USER_DATA', {})
        commit('SET_BRANCH_DATA', {})
        commit('SET_BRANCH_LOGO', null)
        commit('SET_FEATURES', defaultFeatures)
        commit('SET_UNREAD_NOTIFICATIONS', 0)
        commit('SET_COMPANIES', [])
        resolve()
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        // removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js